export const ConsumerAssetSubtypeErrorUat = {
    error: 'workflow.consumerAssetSubtype.error'
}